const TypeValues = {
    1: { value: 1, label: 'ADMIN' },
    2: { value: 2, label: 'GUEST' },
    3: { value: 3, label: 'CREATOR' },
} as const;

export default TypeValues;
